<div class="container">
  <div class="mb-3">
    <fgb-tab
      [tabs]="['games.tab.live.upcoming' | translate, 'games.tab.results' | translate]"
      (tabSelectionChange)="onTabChage($event)"
    />
  </div>
  <ng-container *ngIf="showGames; else showResult">
    <ng-container
      *ngIf="
        {
          pendingGames: pendingGames$ | async,
          currentGames: currentGames$ | async,
        } as games;
        else noGames
      "
    >
      <ng-container *ngIf="!!games.currentGames?.length || !!games.pendingGames?.length; else noGames">
        <ng-container *ngIf="games.currentGames && !!games.currentGames.length">
          <div class="row">
            <div class="col-lg-6 col-12">
              <fgb-fantasy-game-panel
                [game]="games.currentGames[0]"
                (button)="goToDetail(games.currentGames[0].GameId)"
                [buttonState]="hasActivePlayer(games.currentGames[0]) ? 'player-link' : 'no-player-link'"
              ></fgb-fantasy-game-panel>
            </div>
            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
              <div *ngIf="games.currentGames[1]; else noGame">
                <fgb-fantasy-game-panel-next-game [game]="games.currentGames[1]"> </fgb-fantasy-game-panel-next-game>
              </div>
              <ng-template #noGame>
                <div class="no-game-panel card border d-flex align-items-center justify-content-center">
                  <h4 class="text-primary">{{ 'pick.player.game.panel.placeholder' | translate }}</h4>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #showResult>
    <fgb-fantasy-history-list> </fgb-fantasy-history-list>
  </ng-template>

  <!--Placeholder Information-->
  <ng-template #noGames>
    <ng-container *ngIf="showGames">
      <div class="no-items w-100 text-center border rounded pt-5 pb-4 mt-4">
        <div
          class="svg svg-info vs-svg ms-auto me-auto"
          fgbAnimateSvg
          [inlineSVG]="'games/PickaPlayer.svg' | contentAssetImage"
        ></div>
        <p class="text-black text-center font-size-14 mt-2 mb-0">{{ 'pick.player.placeholder.description' | translate }}</p>
      </div>
    </ng-container>
  </ng-template>
</div>
